import React from 'react';
import { Eye, EyeOff } from 'lucide-react';

// Campi Nome/Cognome + Password/Conferma dell'accettazione invito. Estratti in
// componente dedicato per tenere InviteAcceptForm.tsx sotto le ~250 righe.
interface InviteCredentialFieldsProps {
  firstName: string;
  lastName: string;
  onFirstNameChange: (value: string) => void;
  onLastNameChange: (value: string) => void;
  nameErrors: { firstName?: string; lastName?: string };
  password: string;
  confirmPassword: string;
  onPasswordChange: (value: string) => void;
  onConfirmPasswordChange: (value: string) => void;
  passwordError: string | null;
}

export function InviteCredentialFields({
  firstName,
  lastName,
  onFirstNameChange,
  onLastNameChange,
  nameErrors,
  password,
  confirmPassword,
  onPasswordChange,
  onConfirmPasswordChange,
  passwordError,
}: InviteCredentialFieldsProps) {
  const [showPassword, setShowPassword] = React.useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = React.useState(false);
  const passwordsMatch = password.length > 0 && password === confirmPassword;

  return (
    <>
      <div className="grid grid-cols-2 gap-4">
        <div className="space-y-1.5">
          <label className="block text-sm font-medium text-[#37352F]">Nome</label>
          <input
            type="text"
            value={firstName}
            onChange={(e) => onFirstNameChange(e.target.value)}
            className={`notion-typing-input w-full py-2.5 px-3 text-sm ${nameErrors.firstName ? '!border-red-500' : ''}`}
            placeholder="Mario"
            required
          />
          {nameErrors.firstName && <p className="text-xs text-red-600">{nameErrors.firstName}</p>}
        </div>
        <div className="space-y-1.5">
          <label className="block text-sm font-medium text-[#37352F]">Cognome</label>
          <input
            type="text"
            value={lastName}
            onChange={(e) => onLastNameChange(e.target.value)}
            className={`notion-typing-input w-full py-2.5 px-3 text-sm ${nameErrors.lastName ? '!border-red-500' : ''}`}
            placeholder="Rossi"
            required
          />
          {nameErrors.lastName && <p className="text-xs text-red-600">{nameErrors.lastName}</p>}
        </div>
      </div>

      <div className="space-y-1.5">
        <label className="block text-sm font-medium text-[#37352F]">Password</label>
        <div className="relative">
          <input
            type={showPassword ? 'text' : 'password'}
            value={password}
            onChange={(e) => onPasswordChange(e.target.value)}
            className="notion-typing-input w-full py-2.5 pl-3 pr-10 text-sm"
            placeholder="Almeno 8 caratteri"
            required
          />
          <button
            type="button"
            onClick={() => setShowPassword(!showPassword)}
            className="absolute right-3 top-1/2 -translate-y-1/2 text-[#787774] hover:text-[#37352F] transition-colors"
          >
            {showPassword ? <EyeOff className="w-4 h-4" /> : <Eye className="w-4 h-4" />}
          </button>
        </div>
      </div>

      <div className="space-y-1.5">
        <label className="block text-sm font-medium text-[#37352F]">Conferma password</label>
        <div className="relative">
          <input
            type={showConfirmPassword ? 'text' : 'password'}
            value={confirmPassword}
            onChange={(e) => onConfirmPasswordChange(e.target.value)}
            className={`notion-typing-input w-full py-2.5 pl-3 pr-10 text-sm ${confirmPassword && !passwordsMatch ? '!border-red-500' : ''}`}
            placeholder="Ripeti la password"
            required
          />
          <button
            type="button"
            onClick={() => setShowConfirmPassword(!showConfirmPassword)}
            className="absolute right-3 top-1/2 -translate-y-1/2 text-[#787774] hover:text-[#37352F] transition-colors"
          >
            {showConfirmPassword ? <EyeOff className="w-4 h-4" /> : <Eye className="w-4 h-4" />}
          </button>
        </div>
        {passwordError && <p className="text-xs text-red-600">{passwordError}</p>}
      </div>
    </>
  );
}

export default InviteCredentialFields;
